document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ss-home-goals]').forEach((root) => {
    const buttons = [...root.querySelectorAll('[data-ss-home-goal-button]')];
    const panels = [...root.querySelectorAll('[data-ss-home-goal-panel]')];
    if (!buttons.length || !panels.length) return;

    const availableKeys = panels.map((panel) => panel.dataset.ssHomeGoalPanel);
    const requestedKey = new URLSearchParams(window.location.search).get('goal');

    const activate = (key) => {
      const activeKey = availableKeys.includes(key) ? key : availableKeys[0];
      buttons.forEach((button) => {
        const active = button.dataset.ssHomeGoalButton === activeKey;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        const active = panel.dataset.ssHomeGoalPanel === activeKey;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    activate(requestedKey);
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const key = button.dataset.ssHomeGoalButton;
        activate(key);
        window.history.pushState({}, '', button.href);
        document.querySelector('#recommendation')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    window.addEventListener('popstate', () => {
      activate(new URLSearchParams(window.location.search).get('goal'));
    });
  });

  document.querySelectorAll('[data-ss-goals]').forEach((root) => {
    const buttons = [...root.querySelectorAll('[data-ss-goal-button]')];
    const panels = [...root.querySelectorAll('[data-ss-goal-panel]')];
    const activate = (key) => {
      const available = buttons.some((button) => button.dataset.ssGoalButton === key);
      const activeKey = available ? key : buttons[0]?.dataset.ssGoalButton;
      if (!activeKey) return;
      buttons.forEach((item) => {
        const active = item.dataset.ssGoalButton === activeKey;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        const active = panel.dataset.ssGoalPanel === activeKey;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    activate(window.location.hash.replace('#', ''));
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const key = button.dataset.ssGoalButton;
        activate(key);
        window.history.replaceState({}, '', `#${key}`);
      });
    });
  });
});
